import { render, staticRenderFns } from "./MenuArea.vue?vue&type=template&id=5b70a5f4&scoped=true&"
import script from "./MenuArea.vue?vue&type=script&lang=js&"
export * from "./MenuArea.vue?vue&type=script&lang=js&"
import style0 from "./MenuArea.vue?vue&type=style&index=0&id=5b70a5f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70a5f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b70a5f4')) {
      api.createRecord('5b70a5f4', component.options)
    } else {
      api.reload('5b70a5f4', component.options)
    }
    module.hot.accept("./MenuArea.vue?vue&type=template&id=5b70a5f4&scoped=true&", function () {
      api.rerender('5b70a5f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/MenuArea/MenuArea.vue"
export default component.exports